import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const eventState = () => {
    return {
        eventBaseURL: process.env.VUE_APP_BASE_URL,
        timeZones: [],
        isSubmitChapterEvent: null,
        eventCustomField: null,
        cventLookup: null,
    };
};
const eventMutations = {
    [storeMutation.setTimeZones]: (state, data) => {
        state.timeZones = data;
    },
    [storeMutation.setChapterEvent]: (state, data) => {
        state.isSubmitChapterEvent = data;
    },
    [storeMutation.setEventCustomField]: (state, data) => {
        state.eventCustomField = data;
    },
    [storeMutation.setCventLookup]: (state, data) => {
        state.cventLookup = data;
    },
};
const eventActions = {
    [storeAction.getTimeZones]: wrapAction(storeAction.getTimeZones, async ({ state, commit }) => {
        return axios({
            url: `${state.eventBaseURL}events/api/chapterevent/get-time-zones`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTimeZones, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.submitChapterEvent]: wrapAction(storeAction.submitChapterEvent, ({ state, commit }, objectToSubmit) => {
        return axios({
            url: `${state.eventBaseURL}events/api/chapterevent/create-cvent`,
            headers: getBasicHeaders(),
            data: objectToSubmit,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setChapterEvent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getCventLookup]: wrapAction(storeAction.getCventLookup, async ({ state, commit }, communityId) => {
        return axios({
            url: `${state.eventBaseURL}events/api/chapterevent/get-cvent-lookup/`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setCventLookup, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.getEventCustomField]: wrapAction(storeAction.getEventCustomField, async ({ state, commit }, communityId) => {
        return axios({
            url: `${state.eventBaseURL}events/api/chapterevent/get-cvent-custom-fields`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEventCustomField, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};
const eventGetters = {
    [storeGetters.timeZones]: state => state.timeZones,
    [storeGetters.isSubmitChapterEvent]: state => state.isSubmitChapterEvent,
    [storeGetters.eventCustomField]: state => state.eventCustomField,
    [storeGetters.cventLookup]: state => state.cventLookup,
};
export default {
    namespaced: true,
    state: {
        initialState: eventState(),
        ...eventState(),
    },
    mutations: { ...eventMutations },
    actions: { ...eventActions },
    getters: { ...eventGetters },
};
